export default __webpack_public_path__ + "static/media/stephanie_tommy-184.9f0a366a.jpg";